module.exports = __webpack_public_path__ + "img/slide3.39fbc384.jpg";